'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Logo = require('../Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _hamburger = require('../shapes/hamburger');

var _SideNav = require('./SideNav');

var _SideNav2 = _interopRequireDefault(_SideNav);

var _reactSmoothCollapse = require('react-smooth-collapse');

var _reactSmoothCollapse2 = _interopRequireDefault(_reactSmoothCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sideNavOpen: false,
      requiredSpace: -1,
      mobileNavOpen: false,
      forceMobile: false
    }, _this.toggleSideNav = function () {
      _this.setState({ sideNavOpen: !_this.state.sideNavOpen });
    }, _this.toggleMobileNav = function () {
      _this.setState({ mobileNavOpen: !_this.state.mobileNavOpen });
    }, _this.setRef = function (el) {
      if (el) _this[el.attributes['data-ref'].value] = el;
    }, _this.calculateResponsive = function () {
      if (_this.state.mobileNavOpen) _this.setState({ mobileNavOpen: false });
      var styles = window.getComputedStyle(_this.fluidNav);
      var padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
      var forceMobile = _this.fluidNav.clientWidth - padding <= _this.state.requiredSpace;
      if (_this.state.forceMobile !== forceMobile) _this.setState({ forceMobile: forceMobile });
    }, _this.updateRequiredSpace = function () {
      var fluidNavTabs = _this.fluidNavTabs;
      var fluidNavTitle = _this.fluidNavTitle;
      if (!_this.state.mobileNavOpen && fluidNavTitle && fluidNavTitle.offsetWidth && fluidNavTabs && fluidNavTabs.offsetWidth) {
        var requiredSpace = fluidNavTabs.offsetWidth + fluidNavTitle.offsetWidth;
        if (_this.state.requiredSpace < requiredSpace) _this.setState({ requiredSpace: requiredSpace }, _this.calculateResponsive);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.responsive) {
        this.updateRequiredSpace();
        window.addEventListener('resize', this.calculateResponsive);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.responsive && !this.state.mobileNavOpen) {
        this.updateRequiredSpace();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.calculateResponsive);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          appTitle = _props.appTitle,
          appLinks = _props.appLinks,
          profile = _props.profile,
          notifications = _props.notifications;

      var mobileNavOpen = this.state.forceMobile && this.state.mobileNavOpen;
      var navLinks = _react2.default.createElement(
        'ul',
        {
          onMouseDown: function onMouseDown(e) {
            return _this2.state.mobileNavOpen ? e.preventDefault() : undefined;
          },
          className: 'nav nav-tabs ' + (this.state.forceMobile ? 'nav-stacked' : ''),
          style: this.state.forceMobile ? { paddingBottom: 10 } : {},
          ref: this.setRef,
          'data-ref': 'fluidNavTabs' },
        appLinks.map(function (link, i) {
          return _react2.default.createElement(
            'li',
            { key: i },
            link
          );
        })
      );
      var showNav = this.props.showLeftNav;
      var fluidNav = _react2.default.createElement(
        'div',
        { className: 'navbar-fluid ' + (this.state.requiredSpace || this.props.appLinks.length === 0 ? '' : 'sizer') },
        _react2.default.createElement(
          'nav',
          { className: 'navbar navbar-block subtitle', ref: this.setRef, 'data-ref': 'fluidNav' },
          _react2.default.createElement(
            'div',
            { className: 'navbar-header', ref: this.setRef, 'data-ref': 'fluidNavTitle' },
            _react2.default.createElement(
              'span',
              {
                className: 'navbar-toggle clickable',
                onClick: this.toggleMobileNav,
                style: this.state.forceMobile ? { outline: 'none', paddingBottom: 10 } : {},
                tabIndex: '2',
                onBlur: function onBlur() {
                  return _this2.setState({ mobileNavOpen: false });
                } },
              'Menu ',
              _react2.default.createElement('span', { className: 'caret' })
            ),
            _react2.default.createElement(
              'h2',
              null,
              appTitle
            ),
            _react2.default.createElement(
              _reactSmoothCollapse2.default,
              { expanded: mobileNavOpen },
              navLinks
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'fluid-collapse navbar-fluid-collapse navbar-right' },
            navLinks
          )
        )
      );
      return _react2.default.createElement(
        'div',
        null,
        showNav ? _react2.default.createElement(_SideNav2.default, {
          sideNavOpen: this.state.sideNavOpen,
          toggleSideNav: this.toggleSideNav,
          language: this.props.language,
          environment: this.props.environment,
          activeNavLinkId: this.props.appId
        }) : null,
        _react2.default.createElement(
          'nav',
          { className: 'navbar navbar-default' },
          showNav ? _react2.default.createElement(
            'span',
            { className: 'hamburger', onClick: this.toggleSideNav },
            _react2.default.createElement(_hamburger.Hamburger, null)
          ) : null,
          _react2.default.createElement(
            'div',
            { className: 'navbar-brand', style: !showNav ? { marginLeft: '0px' } : {} },
            _react2.default.createElement(_Logo2.default, { width: '107px' })
          ),
          notifications,
          _react2.default.createElement(
            'div',
            { className: 'dropdown mcp-navbar-userbox' },
            profile
          )
        ),
        this.state.forceMobile ? _react2.default.createElement('div', { className: 'forceMobile', children: fluidNav }) : fluidNav
      );
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;


Header.propTypes = {
  appTitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  appLinks: _propTypes2.default.arrayOf(_propTypes2.default.node),
  profile: _propTypes2.default.node,
  notifications: _propTypes2.default.node,
  appId: _propTypes2.default.string,
  showLeftNav: _propTypes2.default.bool,
  language: _propTypes2.default.string,
  environment: _propTypes2.default.string,
  responsive: _propTypes2.default.bool
};

Header.defaultProps = {
  appLinks: [],
  showLeftNav: true,
  responsive: false,
  language: 'en',
  environment: 'prd'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/Header/index.js
// module id = 448
// module chunks = 0